import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { GetListService } from '../../service/getlist.service';
import { PostService } from '../../service/post.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonFunction } from '../../service/commonfunction';

@Component({
  selector: 'app-popupinbox',
  templateUrl: './popupinbox.component.html',
  styleUrls: ['./popupinbox.component.scss']
})
export class PopupinboxComponent implements OnInit {
  ConversationId;
  Id;
  DateSent;
  UserAllMessageList: any;
  ChatFormGroup: UntypedFormGroup;
  compose;
  isCompose = true;
  childUserId = 0;
  hdn_StudentUserId;
  drp_studentList;
  userId;
  roleId;
  txtmsg;
  convid;
  userdata;
  constructor(
    public dialogRef: MatDialogRef<PopupinboxComponent>,
    public route: ActivatedRoute,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public datePipe: DatePipe,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    public formBuilder: UntypedFormBuilder,
    public commonFunction: CommonFunction,
    public getlistservice: GetListService,
    public postservice: PostService,
    public fb: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.ConversationId = null;
    this.Id = null;
    this.DateSent = null;
    this.userdata = this.commonFunction.GetUserData();
    this.roleId = this.userdata.RoleTypeId;
    this.userId = this.userdata.UserId;
    this.AllMessages();
  }
  initForm() {
    this.ChatFormGroup = this.formBuilder.group(
      {
        textmessage: new UntypedFormControl(''),
      });
  }
  get f() { return this.ChatFormGroup.controls; }

  onclick() {
    var element = <HTMLInputElement>document.getElementById("menu-sidebar-left-1");
    element.classList.add('menu-active');
  }
  onremoveclick() {
    var element = <HTMLInputElement>document.getElementById("menu-sidebar-left-1");
    element.classList.remove('menu-active');
  }

  closemodel() {
    this.router.navigate(['/usermessages']);
    this.dialogRef.close();
  }

  public AllMessages() {
    this.UserAllMessageList = [];
    this.ConversationId;// = this.data.item.ConversationId;
    this.Id;// = this.data.item.Id;
    if (this.Id != undefined && this.Id != null && this.Id != "" && this.ConversationId != undefined && this.ConversationId != null && this.ConversationId != "") {
      this.getlistservice
        .GetAllMessages(this.Id, this.ConversationId)
        .subscribe((response: any) => {
          this.UserAllMessageList = response;
          this.spinner.hide();
        },
          (error) => {
            this.spinner.hide();
          });
    }
  }

  MessagesSubmit(compose) {
    this.isCompose = compose;
    this.txtmsg = this.ChatFormGroup.controls['textmessage'].value;
    this.ChatFormGroup.setValue({ textmessage: '' });

    if (this.isCompose) {
      if (this.txtmsg != '') {

        this.postservice
          .SendMessage(this.userId, this.roleId, this.txtmsg, this.ConversationId, this.childUserId)
          .subscribe((response: any) => {
            this.ConversationId = response;
            this.txtmsg = "";
            this.spinner.show();
            this.router.navigate(['/usermessages'])
              .then(() => {
                window.location.reload();
              });
            this.dialogRef.close();
            this.spinner.hide();
          },
            (error) => {
              this.spinner.hide();
            });
      }
    }
    else {
      if (this.txtmsg != '') {
        this.postservice
          .SendMessage(this.userId, this.roleId, this.txtmsg, this.ConversationId, this.childUserId)
          .subscribe((response: any) => {
            this.ConversationId = response;
            this.spinner.hide();
            this.AllMessages();
          },
            (error) => {
              this.spinner.hide();
            });
      }
    }
  }
}
